import { toast } from "react-toastify";
import { PUBLIC_BASE_URL } from "../constants";

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export const subscribeUser = async (eventId) => {
  try {
    const registration = await navigator.serviceWorker.ready;
    let subscription = await registration.pushManager.getSubscription();

    if (subscription) {
      await subscription.unsubscribe();
    }
    const response = await fetch(
      `${PUBLIC_BASE_URL}/notifications/vapidPublicKey`
    );
    const { publicKey } = await response.json();
    const convertedVapidKey = urlBase64ToUint8Array(publicKey);

    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: convertedVapidKey,
    });

    const deviceId = crypto.randomUUID();

    localStorage.setItem(
      "pushSubscription",
      JSON.stringify({
        subscription,
      })
    );

    await fetch(`${PUBLIC_BASE_URL}/notifications/subscribe`, {
      method: "POST",
      body: JSON.stringify({
        subscription,
        platform: "web",
        deviceId,
        eventId,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    toast.success("Successfully subscribed to notifications!", {
      autoClose: 3000,
      closeOnClick: true,
      pauseOnHover: false,
    });
    return subscription;
  } catch (error) {
    toast.error("Failed to subscribe to notifications.", {
      autoClose: 3000,
      closeOnClick: true,
      pauseOnHover: false,
    });
    console.error("Failed to subscribe the user: ", error);
    return null;
  }
};
